import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
// import { JwtHelperService } from '@auth0/angular-jwt';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { User } from '../_models/user';
import { UserToCreate } from '../_models/user/userToCreate';
import { UserService } from './user.service';
import { ChangePassword } from '../_models/changepassword';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl = environment.apiUrl + 'auth/';
  // jwtHelper = new JwtHelperService();
  decodedToken: any;
  currentUser: User;
  // systemSetting: SystemSetting[];

  constructor(
    private http: HttpClient,
    private toastrService: ToastrService,
    private routerService: Router,
    private UserService: UserService,
    // private jwtHelperService: JwtHelperService
    // ,
    // private notificationsService: NotificationsService
  ) { }

  login2(model: any) {
    return this.http.post(this.baseUrl + 'login', model).pipe(
      map((response: any) => {
        const user = response;
        if (user) {
          // console.log('start login')
          localStorage.clear();
          localStorage.setItem('token', user.token);
          localStorage.setItem('user', JSON.stringify(user.user));
          // this.decodedToken = this.jwtHelper.decodeToken(user.token);
          if (user.user.empID > 0 ) {
            localStorage.setItem('empname', user.user.employeeName);
            localStorage.setItem('empid', user.user.empID.toString());
          } else {
            localStorage.setItem('empname', this.decodedToken.unique_name);
          }
        }
      })
    );
  }

  login(model: any) {
      let test = this.http.post(this.baseUrl + 'login', model).pipe(
        map((response: any) => {
          const user = response;
          if (user) {

            localStorage.clear();
            localStorage.setItem('token', user.token);
            // localStorage.setItem('user', JSON.stringify(user.user));
            this.UserService.getCurrentUserInfo().subscribe((res)=>{

            localStorage.setItem('user', JSON.stringify(res));

            },error=>{
            });
            // this.decodedToken = this.jwtHelper.decodeToken(user.token);
            if (user.user.empID > 0 ) {
              localStorage.setItem('empname', user.user.employeeName);
              localStorage.setItem('empid', user.user.empID.toString());
            } else {
              // localStorage.setItem('empname', this.decodedToken.unique_name);
            }

            new Promise(function(resolve, reject) {
              setTimeout(function() {
                resolve(true);
              }, 1000);
            });
          }
        })


      );

      return test;
    }

  register(userToCreate: UserToCreate) {
    return this.http.post(this.baseUrl + 'register', userToCreate);
  }

  loggedIn() {
    const token = localStorage.getItem('token');
    // return !this.jwtHelper.isTokenExpired(token);
    return token;
  }

  roleMatch(allowedRoles): boolean {
    let isMatch = false;
    const userRoles = this.decodedToken.role as Array<string>;
    // set current user's role
    localStorage.setItem('roles', userRoles.toString());
    allowedRoles.forEach(element => {
      if (userRoles.includes(element)) {
        isMatch = true;
        return;
      }
    });
    return isMatch;
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('empid');
    this.toastrService.success('Logged out!');
    setTimeout(() => {
      this.routerService.navigate(['pages/login']);
    },1000)

  }

  // SystemSetting(): Observable<SystemSetting[]> {
  //     return this.http.get<SystemSetting[]>(this.baseUrl + 'activesystemsettings');
  // }
}
